/* eslint-disable react-hooks/rules-of-hooks */
// dataValidationTable.tsx
import { useEffect, useState } from 'react';
import {
  Card,
  Typography,
  Button,
  Grid,
  Paper,
  Container,
  TextField,
  FormControlLabel,
  Theme,
  Switch,
  Box,
  Stack,
  IconButton,
} from '@mui/material';
import './styles.css'; // Import the CSS file
import { useDialog } from 'Contexts/Modals/ModalProvider';
import { ipayNet, newServer } from 'constants/constants';
import { useLogin } from 'Contexts/AuthProvider/AuthProvider';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface data {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  attachmentUrl: string; // Add the appropriate type for attachment URL
  attachmentUrl2: string; // Add the appropriate type for attachment URL
  ipAddress: string;
  type: string;
  address1: string;
  address2: string;
  city: string;
  postalCode: string;
  // selectedBusinessType: string;
  businessName: string;
  userIdImgs: string[];
  doingBusinessAs: string;
  businessType: string;
  ein: string;
  ssn: string;
  website: string;
  phone: string;
  correlationId: string;
  businessClassification: string;
  state: string;
  dateOfBirth: string;
  industry: string;
  controller: {
    firstName: string;
    lastName: string;
    title: string;
    dateOfBirth: string;
    ssn: string;
    ownershipPercent: string;
    address: {
      address1: string;
      address2: string;
      city: string;
      stateProvinceRegion: string;
      postalCode: string;
      country: string;
    };
  };
}

// Hook de estilos personalizados

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  textField: {
    marginBottom: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1, 0),
  },
}));

interface dataValidationTableProps {
  data: data;
  goBack: () => void;
}

const EnrollItem = ({ data, goBack }: dataValidationTableProps) => {
  const { openDialog } = useDialog();
  const [image1, setImage1] = useState<string>();
  const [image2, setImage2] = useState<string>();
  const [details, setDetails] = useState<string>();
  const { user } = useLogin();
  const classes = useStyles();

  useEffect(() => {
    if (data.userIdImgs) {
      cargarImagenes();
    }
  }, []);

  const cargarImagenes = async () => {
    try {
      const res = await fetch(`${newServer}aws/get-identification-request/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ipayNet.apiToken,
          Authorization: `Bearer ${user?.token}`,
        },
      });

      const images: { imageUrls: string[] } = await res.json();

      for (let image of images.imageUrls) {
        if (image.includes(data.userIdImgs[0])) {
          setImage1(image);
        }
        if (image.includes(data.userIdImgs[1])) {
          setImage2(image);
        }
      }
    } catch (error) {
      console.log('cargarImagenes', error);
    }
  };

  /**
   * Handle request
   * @param status
   */
  const handleRequest = async (status: string) => {
    let acceptedStatus = 3;
    if (status === 'accept') {
      acceptedStatus = 2;
    }
    try {
      const res = await fetch(`${newServer}requests/status-internal/${data.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ipayNet.apiToken,
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify({
          status_dwolla: acceptedStatus,
          status_usio: acceptedStatus,
        }),
      });
      const responseText = await res.text();
      if ((await responseText) === 'OK') {
        goBack();
      } else {
        openDialog('information', null, {
          title: 'Error',
          description: 'The application could not be modified: ' + responseText,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Handle Aprove
   */
  const handleApprove = () => {
    openDialog('information', null, {
      title: 'Approval Request',
      description: 'Are you sure you want to approve this request',
      cancelText: 'Cancel',
      onConfirm: () => handleRequest('accept'),
    });
  };

  /**
   * Handle deny
   */
  const handleDeny = () => {
    openDialog('information', null, {
      title: 'Deny Request',
      input: details,
      setInput: (value: string) => setDetails(value as any),
      inputPlaceholder: 'Please provide a reason for the denial',
      description: 'Are you sure you want to deny this request',
      cancelText: 'Cancel',
      onConfirm: () => handleRequest('deny'),
      isMultiline: true,
    });
  };

  return (
    <Box
      component='main'
      sx={{
        flexGrow: 1,
        py: 8,
        bgcolor: 'white',
        minHeight: '100vh',
      }}
    >
      <Container maxWidth='xl'>
        <Stack spacing={3}>
          <Stack direction='row' alignItems='center' spacing={2}>
            <IconButton
              onClick={goBack}
              sx={{
                bgcolor: '#f8fafc',
                '&:hover': { bgcolor: '#f1f5f9' },
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Stack spacing={1}>
              <Typography variant='h4' sx={{ color: '#1e293b' }}>
                Request Details
              </Typography>
              <Typography color='text.secondary' variant='subtitle2'>
                Review and manage enrollment request information
              </Typography>
            </Stack>
          </Stack>

          <Card
            sx={{
              p: 3,
              bgcolor: '#fff',
              boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Stack spacing={3}>
                  <div>
                    <Typography
                      variant='h6'
                      sx={{ mb: 2, color: '#1e293b' }}
                    >
                      Personal Information
                    </Typography>
                    <section className='personal-info'>
                      <Typography
                        variant='body2'
                        color='textSecondary'
                        gutterBottom
                      >
                        Name: {data.firstName} {data.lastName}
                      </Typography>
                      <Typography
                        variant='body2'
                        color='textSecondary'
                        gutterBottom
                      >
                        Email: {data.email}
                      </Typography>
                      <Typography
                        variant='body2'
                        color='textSecondary'
                        gutterBottom
                      >
                        Phone: {data.phone}
                      </Typography>
                      <Typography
                        variant='body2'
                        color='textSecondary'
                        gutterBottom
                      >
                        Date of Birth: {data.dateOfBirth}
                      </Typography>
                    </section>
                  </div>

                  <div>
                    <Typography
                      variant='h6'
                      sx={{ mb: 2, color: '#1e293b' }}
                    >
                      Business Information
                    </Typography>
                    <section className='business-info'>
                      <Typography
                        variant='body2'
                        color='textSecondary'
                        gutterBottom
                      >
                        Business Name: {data.businessName}
                      </Typography>
                      <Typography
                        variant='body2'
                        color='textSecondary'
                        gutterBottom
                      >
                        Business Type: {data.businessType}
                      </Typography>
                      <Typography
                        variant='body2'
                        color='textSecondary'
                        gutterBottom
                      >
                        EIN: ****
                        {data.ein.substring(data.ein.length - 4, data.ein.length)}
                      </Typography>
                      <Typography
                        variant='body2'
                        color='textSecondary'
                        gutterBottom
                      >
                        Website:{' '}
                        <a
                          href={data.website}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {data.website}
                        </a>
                      </Typography>
                    </section>
                  </div>

                  {data.controller && (
                    <div>
                      <Typography
                        variant='h6'
                        sx={{ mb: 2, color: '#1e293b' }}
                      >
                        Controller Information
                      </Typography>
                      <section className='controller-info'>
                        <Typography
                          variant='body2'
                          color='textSecondary'
                          gutterBottom
                        >
                          Controller: {data.controller.firstName}{' '}
                          {data.controller.lastName}
                        </Typography>
                        <Typography
                          variant='body2'
                          color='textSecondary'
                          gutterBottom
                        >
                          Controller Title: {data.controller.title}
                        </Typography>
                        <Typography
                          variant='body2'
                          color='textSecondary'
                          gutterBottom
                        >
                          Controller Date of Birth: {data.controller.dateOfBirth}
                        </Typography>
                        <Typography
                          variant='body2'
                          color='textSecondary'
                          gutterBottom
                        >
                          Controller SSN: ****
                          {data.controller.ssn.substring(
                            data.controller.ssn.length - 4,
                            data.controller.ssn.length
                          )}
                        </Typography>
                      </section>
                    </div>
                  )}
                </Stack>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant='h6' sx={{ mb: 2, color: '#1e293b' }}>
                  Documents
                </Typography>
                <Stack spacing={2}>
                  {image1 && (
                    <Box
                      sx={{
                        width: '100%',
                        borderRadius: 1,
                        overflow: 'hidden',
                        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                      }}
                    >
                      <img
                        src={image1}
                        alt='Document 1'
                        style={{
                          width: '100%',
                          height: 'auto',
                          display: 'block',
                        }}
                      />
                    </Box>
                  )}
                  {image2 && (
                    <Box
                      sx={{
                        width: '100%',
                        borderRadius: 1,
                        overflow: 'hidden',
                        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                      }}
                    >
                      <img
                        src={image2}
                        alt='Document 2'
                        style={{
                          width: '100%',
                          height: 'auto',
                          display: 'block',
                        }}
                      />
                    </Box>
                  )}
                </Stack>
              </Grid>
            </Grid>

            <Box
              sx={{
                display: 'flex',
                gap: 2,
                mt: 4,
                justifyContent: 'flex-end',
              }}
            >
              <Button
                variant='contained'
                onClick={handleApprove}
                sx={{
                  bgcolor: '#22c55e',
                  '&:hover': { bgcolor: '#16a34a' },
                }}
              >
                Approve
              </Button>
              <Button
                variant='contained'
                onClick={handleDeny}
                sx={{
                  bgcolor: '#ef4444',
                  '&:hover': { bgcolor: '#dc2626' },
                }}
              >
                Deny
              </Button>
            </Box>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
};

export default EnrollItem;
